<template>
  <div class="knowlitem-space">
    <div>
      <know-banner></know-banner>
    </div>
    <div class="knowledge-news">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <h2 class="know-space-title">{{newsObj.title}}</h2>
            <div>
              <el-form :inline="true">
                <el-form-item>
                  <div class="textUtil">分类：{{newsObj.newsType}}</div>
                </el-form-item>
                <el-form-item>
                  <div>来源：{{newsObj.fromWhere}}</div>
                </el-form-item>
                <el-form-item>
                  <div class="textUtil">
                    <img src="../../../../static/img/formIcons/clockB.png" width="20" height="20" alt="">
                    <span>{{newsObj.time}}</span>
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="textUtil">
                    <img @click="toggleAdmire(1)" v-if="!isAdmired" src="../../../../static/img/formIcons/admire1.png" width="18" height="18" alt="">
                    <img @click="toggleAdmire(2)" v-if="isAdmired" src="../../../../static/img/formIcons/admire2.png" width="18" height="18" alt="">
                    <span>{{newsObj.admire}}</span>
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="textUtil">
                    <img src="../../../../static/img/formIcons/eyeB.png" width="20" height="20" alt="">
                    <span>{{newsObj.viewCount}}</span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="news_content" v-html="newsObj.content"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <top-news v-bind:newsType="newsType"></top-news>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import knowBanner from './knowBanner';
import topNews from './topNews';
import * as newsApi from '@/api/frontApi/frontNews';
export default {
  data() {
    return {
      topTenList: [],
      newsObj: {
        title: '',
        subTitle: '',
        content: '',
        viewCount: 238,
        fromWhere: '',
        time: '',
        admire: 190,
        newsType: '',
        knowlesdgeModule: '博士大讲堂',
        path: ''
      },
      isAdmired: false,
      newsId: '',
      newsType: 1
    };
  },
  components: {
    knowBanner,
    topNews
  },
  created() {
    this.newsId = this.$route.params.knowledgeId;
    this.initData(this.newsId);
    this.topArticle();
  },
  beforeDestroy() {
    this.sendViewd(this.newsId);
  },
  methods: {
    initData(data) {
      let that = this;
      newsApi.getNewsById({ newsId: data }).then(res => {
        that.newsObj.title = res.data.newsTitle;
        that.newsObj.time = res.data.newsUpdateTime;
        that.newsObj.path = res.data.newsMainImg;
        that.newsObj.content = res.data.newsText;
        that.newsObj.admire = res.data.newsSupportNum;
        that.newsObj.viewCount = that.viewedPlus(res.data.newsReadNum);
        that.newsObj.newsType = res.data.newsTypeName;
        that.newsObj.fromWhere = res.data.newsAuthor;
      });
    },
    toggleAdmire(toggleType) {
      let toggleSelf = this;
      switch (toggleType) {
        case 1:
          toggleSelf.newsObj.admire++;
          toggleSelf.isAdmired = true;
          break;
        case 2:
          toggleSelf.newsObj.admire--;
          toggleSelf.isAdmired = false;
          break;
      }
    },
    topArticle() {
      let topSelf = this;
      topSelf.topTenList = [];
      newsApi.topTen({ newsType: 2 }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          let tempTenObj = {
            path: '',
            title: '',
            date: '',
            contentTip: '',
            newsId: '',
            isTop3: 0
          };
          tempTenObj.path = res.data[i].newsMainImg;
          tempTenObj.title = res.data[i].newsTitle;
          tempTenObj.data = res.data[i].newsUpdateTime;
          tempTenObj.contentTip = res.data[i].newsSummary;
          tempTenObj.newsId = res.data[i].newsId;
          // tempTenObj.isTop3 = res.data[i].newsId;
          // tempTenObj.admire= res.data[i].newsMainImg;
          // tempTenObj.read= res.data[i].newsMainImg;
          topSelf.topTenList.push(tempTenObj);
        }
      });
    },
    viewedPlus(viewData) {
      let p = parseInt(viewData);
      return ++p;
    },
    sendViewd(currId) {
      newsApi.returnReadNo({ newsId: currId }).then(res => {});
    }
  }
};
</script>
<style scoped>
.knowledge-news {
  width: 70%;
  margin: 0 auto;
  padding: 25px;
  padding-bottom: 20px;
  background-color: #fff;
}
.know-space-title {
  width: 100%;
  text-align: center;
}
.textUtil img {
  margin-top: -3px;
}
img {
  vertical-align: middle;
}
.news_content {
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/knowledge/knowInfo.vue